(function (angular) {
	'use strict';

	angular
		.module('baseCheckoutModule')
		.controller('SelectCountryOfCitizenship', [
			'$window',
			'globalConfig',
			'UserFactory',
			SelectCountryOfCitizenshipFunction
		]);

	function SelectCountryOfCitizenshipFunction(
		$window,
		globalConfig, 
		UserFactory) {

		var checkout = this;

		checkout.$onInit = function () {

			checkout.countries = globalConfig.countries;

			var USIndex = 0;
			
			angular.forEach(checkout.countries, function(country, index){
				if (country.code === 'US') {
					USIndex = index;
				}
			});
			
			checkout.citizenshipCountryCode = checkout.countries[USIndex];
			checkout.residenceCountryCode = checkout.countries[USIndex];
		};

		function buildRequest () {

			var requestBody = {
				"citizenshipCountryCode": checkout.citizenshipCountryCode.code,
				"residenceCountryCode": checkout.residenceCountryCode.code
			};

			return requestBody;
		}


		function submitForm () {
			$window.document.getElementById('citizenshipForm').submit();
		}

		checkout.submit = function () {
			UserFactory.saveCitizenship(buildRequest(), checkout.citizenshipForm)
			.then(function(response) {
				submitForm();
			})
			.catch(function(response) {
				checkout.formSubmitted = false;
			});
		};
	}
})(window.angular);